import React from 'react'
import { useFilters } from './useFilters'
import { FilterSelect } from './FilterSelect/FilterSelect'
import { FilterBubble } from './FilterBubble/FilterBubble'

const component = 'jobs-search'

export function Filters() {
    const { allFilters } = useFilters()

    return (
        <>
            <FilterSelect
                placeholder="Function"
                filterItems={allFilters.function}
                isMoreFilter={false}
                filterField="function"
            />
            <FilterSelect
                placeholder="Location"
                filterItems={allFilters.location}
                isMoreFilter={false}
                filterField="location"
            ></FilterSelect>
            <FilterSelect
                placeholder="Level"
                filterItems={allFilters.experienceLevel}
                isMoreFilter={true}
                filterField="experienceLevel"
            ></FilterSelect>
        </>
    )
}
